import { AbstractQueryAction, ActionData } from '../../http/data_query';
import { DocumentId } from '../classes/document_id';
import { ManyRelationsWithDocuments } from './common';
import { normalizeSchemaName } from '../tools';

import { CreateBuilder } from './create_builder';

export class UpdateBuilder implements AbstractQueryAction {

  manyRelationsForCreate: ManyRelationsWithDocuments = {};
  manyRelationsForUpdate: ManyRelationsWithDocuments = {};
  manyRelationsForDelete: ManyRelationsWithDocuments = {};

  private schema: string;

  constructor(
    private queryName: string | null,
    private id: string,
    private document: any
  ) {
    this.schema = DocumentId.parse(id).schema;
  }

  forCreateEmbed = (document: any) => {
    return new CreateBuilder(null, null, document);
  }

  forUpdateEmbed = (document: any) => {
    return new UpdateBuilder(null, document.id, document);
  }

  forDeleteEmbed = (document: any) => {
    return document.id;
  }

  createManyRelation(schemaName: string, relatedField: string, buildDocuments: Function) {
    this.manyRelationsForCreate[`${normalizeSchemaName(schemaName)}/${relatedField}`]
      = buildDocuments(this.forCreateEmbed);

    return this;
  }

  updateManyRelation(schemaName: string, relatedField: string, buildDocuments: Function) {
    this.manyRelationsForUpdate[`${normalizeSchemaName(schemaName)}/${relatedField}`]
      = buildDocuments(this.forUpdateEmbed);

    return this;
  }

  deleteManyRelation(schemaName: string, relatedField: string, buildDocuments: Function) {
    this.manyRelationsForDelete[`${normalizeSchemaName(schemaName)}/${relatedField}`]
      = buildDocuments(this.forDeleteEmbed);

    return this;
  }

  serialize(): ActionData {
    const query: any = {
      action: 'documents.update',
      name: this.queryName,
      params: {
        id: this.id,
        document: this.document
      }
    };

    if (Object.keys(this.manyRelationsForCreate).length > 0) {
      query.params.create_related = {};

      for (const key in this.manyRelationsForCreate) {
        query.params.create_related[key] = this.manyRelationsForCreate[key].map(builder => builder.serializeEmbed());
      }
    }

    if (Object.keys(this.manyRelationsForUpdate).length > 0) {
      query.params.update_related = {};

      for (const key in this.manyRelationsForUpdate) {
        query.params.update_related[key] = this.manyRelationsForUpdate[key].map(builder => builder.serializeEmbed());
      }
    }

    if (Object.keys(this.manyRelationsForDelete).length > 0) {
      query.params.delete_related = {};

      for (const key in this.manyRelationsForDelete) {
        query.params.delete_related[key] = this.manyRelationsForDelete[key];
      }
    }

    return query;
  }

  serializeEmbed() {
    return {
      id: this.document.id,
      document: this.document
    };
  }
}
